import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import AcademicProgram from "../views/AcademicProgram.vue";
import Links from "../views/Links.vue";
import Search from "../views/Search.vue";
import Discover from "../views/Discover.vue";
import EmbeddedLogin from "@/views/EmbeddedLogin";
import NotFound from "@/views/NotFound.vue";
import EmbeddedForm from "@/views/EmbeddedForm";
import EmbeddedOkThxBai from "@/views/EmbeddedOkThxBai";
import TagCloud from "@/views/TagCloud.vue";
import store from "@/store/index.js"
import Help from "@/views/Help.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import ImportBookmarksWizard from "@/views/ImportBookmarksWizard.vue";
import ImportedBookmarks from "@/views/ImportedBookmarks.vue";
import ImportStartPage from "@/views/ImportStartPage.vue";
import UAParser from "@/views/UAParser.vue";
import TermsOfUse from "@/views/TermsOfUse.vue";
import CompleteRegistration from "@/views/CompleteRegistration.vue";
import SharedBookmarkPage from "@/views/SharedBookmarkPage.vue";
import UserProfilePage from "@/views/UserProfilePage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/academic-program",
    name: "AcademicProgram",
    component: AcademicProgram
  },
  {
    path: "/for-pocket-users",
    name: "Home",
    component: Home,
    props: { isPocketMode: true }
  },
  {
    path: "/bookmarks/:owner/:page?",
    name: "linksByOwner",
    component: Links,
    props: true
  },
  {
    path: "/search/:owner",
    name: "search",
    component: Search,
    props: true
  },
  {
    path: "/discover",
    name: "discover",
    component: Discover,
    props: true
  },
  {
    path: "/share/:owner/:linkId",
    name: "SharedBookmarkPage",
    component: SharedBookmarkPage,
    props: true
  },
  {
    path: "/bookmarks/:owner/tag/:tag/:page?",
    name: "linksByOwnerAndTag",
    component: Links,
    props: (route) => ({
      owner: route.params.owner,
      tag: route.params.tag.toLowerCase(),
      page: route.params.page
    })
  },
  {
    path: "/mybookmarks",
    name: "mylinks",
    props: true,
    redirect: (to) => {
      if (!store.state.userLoggedIn) {
        return {
            path: '/embeddedLogin',
            query: {prevUrl: to.fullPath}
        };
      }
      return `/bookmarks/${store.state.loggedInUserName}`;
    }
  },
  {
    path: "/profile",
    name: "UserProfilePage",
    props: true,
    component: UserProfilePage,
    beforeEnter: (to, from, next) => {
        if (!store.state.userLoggedIn) {
            next({ path: '/embeddedLogin', query: {prevUrl: to.fullPath}});
        }
        else next();
    }
  },
  {
    path: "/profile/payment-successful",
    name: "UserProfilePagePaymentSuccessful",
    props: { paymentSuccess: true },
    component: UserProfilePage,
    beforeEnter: (to, from, next) => {
        if (!store.state.userLoggedIn) {
            next({ path: '/embeddedLogin', query: {prevUrl: to.fullPath}});
        }
        else next();
    }
  },
  {
    path: "/404",
    name: "notfound",
    component: NotFound,
    props: true
  },
  {
    path: "/help",
    name: "help",
    component: Help,
    props: true
  },
  {
    path: "/privacy",
    name: "privacy",
    component: PrivacyPolicy,
    props: false
  },
  {
    path: "/terms-of-use",
    name: "termsOfUse",
    component: TermsOfUse,
    props: false
  },
  {
    path: "/embeddedLogin",
    name: "embeddedLogin",
    component: EmbeddedLogin,
    props: true
  },
  {
    path: "/embeddedForm",
    name: "embeddedForm",
    component: EmbeddedForm,
    redirect: (to) => {
      if (!store.state.userLoggedIn) {
        return {
            path: '/embeddedLogin',
            query: {prevUrl: to.fullPath}
        };
      }
      return '/embeddedSaveLink';
    }
  },
  {
    path: "/embeddedSaveLink",
    name: "embeddedSaveLink",
    component: EmbeddedForm,
    props: route => ({
        defaultTitle: route.query.title,
        defaultUrl: route.query.url,
        defaultSuggestedTags: JSON.parse(route.query.suggestedTags || 'null'),
        defaultPreviewImageUrl: route.query.previewImageUrl
    }),
    beforeEnter: (to, from, next) => {
      if (to.query.bookmarkletVersion < process.env.VUE_APP_BOOKMARKLET_VERSION) {
        store.commit("addError", "A new version of the bookmarklet is available. To get the latest features and bugfixes, please remove the bookmarklet and reinsert it from the Help page.");
      }
      next();
    },
  },
  {
    path: "/okthxbai",
    name: "embeddedOkThxBai",
    component: EmbeddedOkThxBai,
    props: true
  },
  {
    path: "/tags/:owner/tagcloud",
    name: "tagCloud",
    component: TagCloud,
    props: true
  },
  {
    path: "/new-import",
    name: "new-import",
    component: ImportBookmarksWizard,
    props: true
  },
  {
    path: "/imports",
    name: "imports",
    component: ImportStartPage,
    props: true
  },
  {
    path: "/imports/:importJobId/:page?",
    name: "importedBookmarks",
    component: ImportedBookmarks,
    props: true
  },
  {
    path: "/complete-registration",
    name: "complete-registration",
    component: CompleteRegistration,
    props: route => ({
            email: route.query.email,
            regCode: route.query.regCode
        })
  },
 {
   path: "/uaParser",
   name: "uaParser",
   component: UAParser
 }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
